import { atom, selector } from 'recoil'
import { getGis2TokenFromStorage, putGis2TokenIntoStorage } from './login.js'

export const gis2TokenAtom = atom({
	key: "gis2TokenAtom",
	default: getGis2TokenFromStorage(),
});

export const isLoggedInSelector = selector({
  key: 'isLoggedIn',
  get: ({get}) => {
    const token = get(gis2TokenAtom);
    const hasToken = !!token

    if (hasToken) {
    	putGis2TokenIntoStorage(token)
    } else {
    	putGis2TokenIntoStorage(null)
    }

    return hasToken
  },
});